<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="85%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :createButtonDisabled="!$can('create','Storage')"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"        
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
      allItemsInStorage: [],
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_STORAGE_SHELF_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.storageShelf;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));        
    },   
    createServerEntry: function(storage) {
      console.log("STORAGE", storage); //, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(storage, this.entry.validations));
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(storage, this.entry.validations);
      console.log("sto filtered", filtered);
      // filtered.shelvesAttributes.forEach(function(item, index){
      //   item.itemIdsAttribute = storage.shelvesAttributes[index].itemIdsAttribute;
      // });
      // console.log("sto filtered2", filtered);      
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_STORAGE_SHELF_MUTATION,
          variables: {
            input: filtered
          }
        })
        .then(response => {
          var errors = response.data.createStorageShelf.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createStorageShelf.storageShelf);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_STORAGE_SHELF_QUERY = gql `
  {
    accountContext {
      storageShelf {
        id
        name
        storageId        
        storageBuildingsAttributes{
          id
          name
          buildingLevelsAttributes{
            id
            name
          }
        }        
        validations
      }
      allItemsInStorage {
        id
        name
        additionalInfo
        secondAdditionalInfo
      }
      allStorages{
        id
        name
        location
      }
    }
  }
`;

const CREATE_STORAGE_SHELF_MUTATION = gql `
  mutation($input: StorageShelfCreateInputObject!) {
    createStorageShelf(input: $input) {
      storageShelf {
        id
        name        
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
